import { normalizeMatchLayout } from 'modules/manager/domain/match-layout';
import {
  DEFAULT_MEDIA_KIND,
  MediaKind,
  isKnownMediaKind,
  primaryKindForTemplateType,
} from 'modules/manager/domain/media-kind';
import { normalizePlayerRanking } from 'modules/manager/domain/player-stats';
import { DEFAULT_TEMPLATE_TYPE, TemplateType, isKnownTemplateType } from 'modules/manager/domain/template-type';
import { MediaManagerTemplateGql } from 'modules/manager/domain/graphql/media-manager-templates';
import { MediaManagerTemplate } from '../interfaces/supabase/media-manager/entity';

const mediaManagerTemplateDataMapper = (template: MediaManagerTemplateGql): MediaManagerTemplate => {
  const templateType = coerceTemplateType(template.templateType);
  return {
    id: template.id,
    name: template.name,
    objects: template.objects ?? [],
    version: template.version,
    order: template.order,
    width: template.width,
    height: template.height,
    tournamentId: template.tournamentId ?? null,
    templateGroupId: template.templateGroupId,
    sportType: template.sportType as MediaManagerTemplate['sportType'],
    templateType,
    mediaKind: coerceMediaKind(template.mediaKind, templateType),
    isDefaultForKind: Boolean(template.isDefaultForKind),
    templateSubtypes: Array.isArray(template.templateSubtypes) ? template.templateSubtypes : [],
    matchLayout: normalizeMatchLayout(template.matchLayout),
    playerRanking: normalizePlayerRanking(template.playerRanking),
    createdAt: template.createdAt,
    updatedAt: template.updatedAt,
  };
};

function coerceTemplateType(value: unknown): TemplateType {
  if (isKnownTemplateType(value as string | undefined | null)) {
    return value as TemplateType;
  }
  if (value !== undefined && value !== null && value !== '') {
    // eslint-disable-next-line no-console
    console.warn(`[media-manager] unknown template_type "${value}" — falling back to "${DEFAULT_TEMPLATE_TYPE}"`);
  }
  return DEFAULT_TEMPLATE_TYPE;
}

function coerceMediaKind(value: unknown, templateType: TemplateType): MediaKind {
  if (isKnownMediaKind(value as string | undefined | null)) {
    return value as MediaKind;
  }
  const primary = primaryKindForTemplateType(templateType);
  if (primary) return primary;
  if (value !== undefined && value !== null && value !== '') {
    // eslint-disable-next-line no-console
    console.warn(`[media-manager] unknown media_kind "${value}" — falling back to "${DEFAULT_MEDIA_KIND}"`);
  }
  return DEFAULT_MEDIA_KIND;
}

export default mediaManagerTemplateDataMapper;
